import * as R from 'ramda'

import { hasAddress } from './hasAddress'

import type { Supplier } from '@ngb-frontend/shared/types'

export const hasSupplier = (x: unknown): x is Supplier =>
  R.allPass([R.pipe(R.prop('street'), hasAddress)])(x)
